//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"DraftAngle",0,"Expression",0],[0,"DrawDirection",1,"Direction",0],[1,"FacetBody",0,"SelectDisplayableObject",0],[0,"IsEditCopy",1,0],[0,"MatchFace",1,0],[1,"PartingObject",0,"SelectDisplayableObject",0],[1,"SelectedCurve",0,"ScCollector",0]],[[[],"GenerateIsoclines",{},0,0]],[]];
SPLM.Facet.RemoveUndercutsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.RemoveUndercutsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;